module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-row"
    }
  }, [_c('div', {
    staticClass: "container-body"
  }, [_c('b-row', {
    attrs: {
      "id": "header-row",
      "align-v": "center"
    }
  }, [(_vm.gameMode === 'boardPlay' && (!_vm.isPlayingBoard && !_vm.isBoardAlreadyPlayed(_vm.boardId))) ? _c('b-col', {
    staticClass: "overlay d-none d-sm-block"
  }, [_c('h4', {
    staticClass: "rounded shadow-sm p-2 mb-2",
    staticStyle: {
      "background-color": "#f0f0f0"
    }
  }, [_vm._v("Bienvenue dans le mode \"tour à tour\"")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("Vous allez découvrir un plateau de jeu préparé par un autre joueur, ces icônes doivent vous permettre de trouver le mot caché. Vous pouvez proposer autant de mots que vous le souhaitez, soyez le plus rapide et comparez vous ensuite aux autres joueurs.")]), _vm._v(" "), _c('p', {
    staticClass: "text-left d-none d-lg-block"
  }, [_vm._v("Vous pouvez mettre en pause le jeu ou le reprendre plus tard grâce aux boutons disponibles sous le chronomètre. Vous pouvez également demander un indice (s'ils sont disponibles pour ce plateau de jeu), le nombre d'indices utilisés pour trouver sera affiché dans le classement final.")]), _vm._v(" "), _c('p', {
    staticClass: "text-middle"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.chrono()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isPlayingBoard === null ? 'Démarrer le jeu' : 'Reprendre le jeu') + "\n          ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isBoardEditable) ? _c('b-col', {
    staticClass: "d-none d-sm-block",
    attrs: {
      "cols": "2"
    }
  }, [_c('ConceptCard')], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "d-sm-none",
    attrs: {
      "cols": "1"
    }
  }), _vm._v(" "), _c('b-col', _vm._l((_vm.colors), function(color, index) {
    return _c('div', {
      key: index,
      staticClass: "row align-items-center rounded shadow-sm guess-row",
      class: {
        'active': color == _vm.selectedColor, 'd-none d-md-flex': !_vm.isBoardEditable && index > 1 && _vm.guessCardsToDisplay[color].length === 0
      },
      attrs: {
        "id": color,
        "droppable": _vm.isBoardEditable
      },
      on: {
        "click": function($event) {
          return _vm.setCurrentColor(color)
        },
        "dragover": _vm.dragover,
        "dragenter": _vm.dragenter,
        "drop": _vm.drop
      }
    }, [_c('div', {
      staticClass: "col-auto guess-icon"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": index === 0 ? 'question-circle' : 'exclamation-circle',
        "color": color,
        "size": "2x"
      }
    })], 1), _vm._v(" "), _c('transition-group', {
      staticClass: "guess-cards",
      attrs: {
        "name": "fade"
      }
    }, _vm._l((_vm.guessCardsToDisplay[color]), function(card, index) {
      return (_vm.gameMode !== 'boardPlay' || _vm.gameModeDisplayBoard) ? _c('div', {
        key: index + 1,
        staticClass: "card"
      }, [_c('Card', {
        attrs: {
          "card-info": card,
          "icon-color": color,
          "add-or-remove": "remove"
        }
      })], 1) : _vm._e()
    }), 0)], 1)
  }), 0)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f0e30a2","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-row.vue
// module id = Z2KQ
// module chunks = 1